import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';
import { LoadingScreen } from 'src/components/loading-screen';
const MachineAPIKeys = lazy(() => import('src/pages/machine-to-machine-api/machine-api-keys'));

export const machineToMachineRoutes = [
  {
    path: 'machine-to-machine-api',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [{ element: <MachineAPIKeys />, path: '' }],
  },
];
